import { useContext, useMemo } from 'react'
import { useQueries } from '@tanstack/react-query'
import GeoContext from 'contexts/geoContext'
import { getChat } from 'tripPlanner/api'
import * as ChatKeys from 'tripPlanner/hooks/reactQueryKeys/chat'
import { buildUserMessageSubtitleByChatId } from 'tripPlanner/pages/chat/recentChatItems'

export default function useUserMessageSubtitles(chatIds: Array<number>, enabled = true) {
  const { currentRegionCode } = useContext(GeoContext)
  const chatDetailQueryOptions = useMemo(() => {
    return chatIds.map(chatId => ({
      queryKey: ChatKeys.detail(chatId),
      queryFn: () => getChat(chatId, currentRegionCode),
      enabled: enabled && !!currentRegionCode,
      staleTime: 30_000,
    }))
  }, [chatIds, enabled, currentRegionCode])

  const chatDetailQueries = useQueries({
    queries: chatDetailQueryOptions,
  })

  return buildUserMessageSubtitleByChatId(
    chatIds,
    chatDetailQueries.map(query => query.data),
  )
}
